const { ADD_PROJECT, LIST_PROJECTS, LIST_PROJECT, UPDATE_PROJECT, GET_CATEGORIES, LIST_PROJECT_FILES, ADD_PROJECT_FILES } = require("../actions/types");
const roles = require('../actions/roles')
const projectReducer = (state = {}, action) => {
  switch (action.type) {
    case LIST_PROJECTS:
      return { ...state, userProjects: action.payload }
    case ADD_PROJECT:
      console.log(state.userProjects)
      return {...state, userProjects: [...state.userProjects, action.payload]}
    case LIST_PROJECT: {
      let project = action.payload
      if (project.collaborators) {
        project.collaborators = project.collaborators.map(collaborator => {
          collaborator.role.name = roles[[collaborator.role.role]]
          return collaborator
        })
      }
      return { ...state, project: action.payload }
    }

    case UPDATE_PROJECT:
      const [key] = Object.keys(action.payload)
      const project = state.project
      project[[key]] = action.payload[[key]]
      return { ...state, project }

    case LIST_PROJECT_FILES: case ADD_PROJECT_FILES:
      let projectFiles = action.payload
      projectFiles.files = projectFiles.files.map(file => {
        file.tags = []
        if (file.file_tags && file.file_tags.length) {
          let [tags] = file.file_tags
          file.tags = Object.keys(tags).map(tag => tags[[tag]]).flat() || []
        }
        file.file_size = file.file_size < (1024 * 1024) ? file.file_size / 1024 + ' KB' : file.file_size / (1024 * 1024) + ' MB'
        return file
      })
      return { ...state, projectFiles: projectFiles }

    case GET_CATEGORIES:
      return { ...state, projectsCategories: action.payload.categories }
    default:
      return state
  }
}

export default projectReducer